import React from "react";

const AlertPopUP = ({ type = "info", title, message, dateTime, onCloseAlert }) => {
  // Set colors based on alert type
  const bgColor = type === "success" ? "bg-green-500" : "bg-blue-500";
  const icon = type === "success" ? "✔️" : "⚙️";

  return (
    <div className="fixed z-50 inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className={`p-6 rounded-lg shadow-lg ${bgColor} text-white max-w-sm text-center`}>
        <div className="text-4xl mb-4">{icon}</div>
        <p className="text-lg font-bold">{title}</p>
        <p className="mt-2 text-lg">{message}</p>
        {dateTime && <p className="text-lg font-bold">{dateTime}</p>}
        <button
          onClick={onCloseAlert}
          className="mt-6 px-4 py-2 bg-white text-blue-500 rounded font-semibold hover:bg-gray-100"
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default AlertPopUP;



// import React, { useState } from "react";
// import Alert from "./Alert";

// const App = () => {
//   const [showAlert, setShowAlert] = useState(true);

//   return (
//     <div>
//       {showAlert && (
//         <Alert
//           type="success" // or "info" based on your needs
//           title="Hurray! Diagnostics is completed!"
//           message="Diagnostics run completed successfully."
//           onClose={() => setShowAlert(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default App;
